import styled from "styled-components";
import { SVGEcoFillSmall } from "@/lib/svg";
import {
  bigLabelTypographicStyle,
  smallLabelTypographicStyle,
} from "@/lib/styles/helpers";

export const Container = styled.div`
  position: relative;
  padding: 1.5rem;

  transition: all 0.1s ease-in;
  &:hover {
    cursor: pointer;
    box-shadow: ${({ theme }) => theme.shadows.panelShadow};
  }
`;

export const Heading = styled.a<{ $isEco?: boolean }>`
  margin-top: ${({ $isEco, theme }) => ($isEco ? 0 : "calc(0.5rem + 22.4px)")};
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  font-size: 1.25rem;

  color: ${({ $isEco, theme }) =>
    $isEco ? theme.colors.greenEco : theme.colors.black};
  font-family: ${({ theme }) => theme.fontFamilies.secondary};
  font-weight: 700;
  line-height: 1.2;

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    cursor: pointer;
    z-index: 1;
  }
`;

export const Title = styled.span`
  display: block;
  flex: 1;
  width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${bigLabelTypographicStyle}
`;

export const Subheading = styled.p`
  margin-bottom: 1rem;
  ${smallLabelTypographicStyle}
  font-weight: 700;
`;

export const EcoLabel = styled.div`
  display: flex;
  margin-bottom: 0.5rem;
  ${smallLabelTypographicStyle}
  font-weight: 700;
  color: ${({ theme }) => theme.colors.greenEco};
`;

export const Icon = styled(SVGEcoFillSmall)`
  width: 1em;
  font-size: 1.25rem;
  margin-right: 0.5rem;
`;
